import { useContext } from "react";
import { useInterval } from "usehooks-ts";

import { ForumAPIContext } from "contexts/forum_api_context";
import { useAppSelector } from "hooks/redux_hooks";
import { PageUnloadReasonType } from "shared/types";
import { selectOrgId } from "store/selectors/classroom";
import { redirectToHome, redirectToLogin } from "utils/classroom";

function AuthPollerTask() {
  const forumAPI = useContext(ForumAPIContext);
  const orgId = useAppSelector(selectOrgId());

  useInterval(async () => {
    const response = await forumAPI.checkAuth();
    // Handle unauthorized/expired session error
    if (response.status === 401) {
      redirectToLogin();
    } else {
      // Handle wrong org
      const responseJson = await response.json();
      const authenticatedOrg = responseJson.org_id;
      if (orgId !== authenticatedOrg) {
        alert(
          `You are currently accessing org ${orgId} but you are logged into org ${authenticatedOrg}. You will now be redirected to the home page.`,
        );
        redirectToHome(PageUnloadReasonType.LOGGED_INTO_WRONG_ORG);
      }
    }
  }, 15 * 1000);

  return null;
}

export { AuthPollerTask };
